export interface Follow {
  id: string;
  followerId: string;
  followingId: string;
  createdAt: Date;
}

export interface FollowWithUser extends Follow {
  userName?: string;
  userEmail?: string;
  userAvatarUrl?: string;
}
